<!-- If we have a local SVG registered render it; otherwise fallback to Material Symbols font ligature.
		 Usage: <icon name="refresh"></icon> will auto-fallback without needing an SVG file. -->
@if (hasLocalSvg()) {
	<mat-icon [svgIcon]="name"></mat-icon>
} @else {
	<span class="material-symbols-outlined icon-fallback" aria-hidden="true">{{ name }}</span>
}